import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injector, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HeaderOverridesService } from '@finder/shared/services/header-overrides/header-overrides.service';
import { TravelAgentService } from '@finder/shared/services/travel-agent/travel-agent.service';
import { TRAVEL_AGENT } from '@finder/shared/constants/app.constants';

@Injectable()
export class HeaderOverrideInterceptor implements HttpInterceptor {

    constructor(
        private injector: Injector,
        private travelAgentService: TravelAgentService,
    ) {}

    /**
     * Add any override headers to the request
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headerOverrideService = this.injector.get(HeaderOverridesService);
        const headers = {};

        // Filter out just the active headers
        const activeHeaders = headerOverrideService.getHeaders().filter(header => header.enabled);

        // If we are on Travel Agent flow, we pass a header so the API can handle it properly
        if (this.travelAgentService.isValidTravelAgentUrl()) {
            activeHeaders.push({
                enabled: true,
                header: TRAVEL_AGENT.header,
                value: 'true'
            });
        }

        // If there are no headers to add stop
        if (activeHeaders.length === 0) {
            return next.handle(req);
        }

        if (activeHeaders.length > 0) {
            // Add the headers to the request
            activeHeaders.forEach(header => {
                headers[header.header] = header.value;
            });
        }

        // Add headers to the request
        req = req.clone({
            setHeaders: headers
        });

        return next.handle(req);
    }
}
